import { Fragment, h } from 'preact';
import styled from 'styled-components';
import DeferButton from '../Invite/DeferButton';
import ImageSection from '../Invite/ImageSection';
import ContentSection from '../Invite/ContentSection';
import ButtonsSection from '../Invite/ButtonsSection';
import FooterSection from '../Invite/FooterSection';
import NewLayoutMobileInvite from './newLayoutMobileInvite';
import { PROVISIONS } from '../../common/constants';
import { useState, useEffect } from 'preact/hooks';
import { convertPxToRem } from '@mdigital/common/dist/utils/html';

const StyledInvitationMainDiv = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: visible;
  display: block;
`;
const StyledInvitationContentDiv = styled.div`
  overflow-y: auto;
  height: ${window.screen.availHeight - 60}px;
  max-height: ${props => props.isInviteReflow ? '100vh' : 'calc(100vh - 35px)'};
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  visibility: ${props => props.visibility};
`;

export default function (props) {
  const isRtl = props.application?.inviteData?.isRtl;
  const [invitationContent,setInvitationContent] = useState(props.invitationContentText);
  const isWithInviteReflow = props.application?.provisions[PROVISIONS.ENABLE_INVITE_REFLOW];
  const vertical = props.application?.invitationJson?.vertical || props.vertical;

  useEffect(() => {
    isWithInviteReflow && setInvitationContent(convertPxToRem(props.application.inviteData?.desktopDesign?.invitationContentText));
  }, [isWithInviteReflow]);

  const renderMobileInviteContent = (props) => {
    return (
      <Fragment>
        <DeferButton
          onClick={props.onDeferButtonClicked}
          isDirectionRtl={isRtl}
          isInviteReflow={isWithInviteReflow}
        />
        <ImageSection
          imageSrc={props.logoUrl}
          onImageLoad={props.onImageLoad}
          isInviteReflow={isWithInviteReflow}
          vertical={vertical}
        />
        <ContentSection content={invitationContent} isInviteReflow={isWithInviteReflow} />
        <ButtonsSection
          provideButtonText={props.provideButtonText}
          provideButtonColor={props.invitationProvideButtonColor}
          provideButtonTextColor={props.invitationProvideButtonTextColor}
          onProvideFeedbackClicked={props.onProvideFeedbackClicked}
          declineButtonText={props.declineButtonText}
          declineButtonColor={props.invitationDeclineButtonColor}
          declineButtonTextColor={props.invitationDeclineButtonTextColor}
          onDeclineButtonClicked={props.onDeclineButtonClicked}
          isInviteReflow={isWithInviteReflow}
        />
      </Fragment>
    )
  };

  if (
    props.application.provisions.mobileInvitationLayout &&
    props.application.inviteData.mobileDesign
  ) {
    return <NewLayoutMobileInvite {...props} />;
  } else {
    return (
      <StyledInvitationMainDiv className="invitationDesignMain mobileAdapter">
        <StyledInvitationContentDiv
          className="kpl-invitation-content"
          vertical={props.vertical}
          visibility={props.isLoadingCustomCss || props.isLoadingLogo ? 'hidden' : 'visible'}
          isInviteReflow={isWithInviteReflow}
        >
          {isWithInviteReflow && (renderMobileInviteContent(props))}
          {!isWithInviteReflow && (<div>
            {renderMobileInviteContent(props)}
          </div>)}
          <FooterSection
            toolTipText={props.helpTooltipText}
            isDirectionRtl={isRtl}
            poweredByTranslation={props.poweredByForScreenReader}
            isInviteReflow={isWithInviteReflow}
          />
        </StyledInvitationContentDiv>
      </StyledInvitationMainDiv>
    );
  }
}
